module.exports = __webpack_public_path__ + "img/sGoldenFa_193x205.399a3a80.png";